import { NotificationsMobilePage } from '@/pages/mobile/shared/NotificationsMobilePage';

export function EmployeeNotificationsPage() {
  return <NotificationsMobilePage variant="employee" />;
}
